import C from "@/components/forms/Checkbox.module.css";
import { mcn } from "@/utils/baseProps.ts";

import type { ReactNode } from "react";
import { Checkbox, type CheckboxProps } from "react-aria-components";

export function WCheckbox({
    children,
    ...props
}: Omit<CheckboxProps, "children" | "className"> & { children?: ReactNode; className?: string }) {
    return (
        <Checkbox {...mcn(C.Checkbox, props)}>
            {({ isIndeterminate }) => (
                <>
                    <div className={C.CheckIcon}>
                        <svg viewBox="0 0 18 18" aria-hidden="true">
                            {isIndeterminate ? (
                                <rect x={1} y={7.5} width={15} height={3} />
                            ) : (
                                <polyline points="1 9 7 14 15 4" />
                            )}
                        </svg>
                    </div>
                    {children}
                </>
            )}
        </Checkbox>
    );
}
